// extracted by mini-css-extract-plugin
export default {"childRow":"childRow___AB99f"};